import { FormattedMessage } from 'react-intl';
import { NavItemType } from 'types/menu';
import { GrHelpBook } from 'react-icons/gr';
import { DOCUMENTATION_URL, GIT_COMMIT_HASH, GIT_BRANCH_NAME } from 'config';

const icons = {
    GrHelpBook,
};

const additional: NavItemType = {
    id: 'additional',
    title: <FormattedMessage id='additional' />,
    type: 'group',
    children: [
        {
            id: 'documentation',
            title: <FormattedMessage id='documentation' />,
            type: 'item',
            url: DOCUMENTATION_URL,
            icon: icons.GrHelpBook,
            external: true,
            target: true,
        },
        {
            id: 'version',
            title: (
                <>
                    <FormattedMessage id='version' />-{GIT_COMMIT_HASH} -{GIT_BRANCH_NAME}
                </>
            ),
            type: 'item',
            disabled: true,
            external: true,
            target: true,
        },
    ],
};

export default additional;
